import type { SessionLoadResult } from '@/lib/server-fns/sessionLoader';

export type RootAuthData<T> = {
  authState: SessionLoadResult<T>['status'];
  session: T | null;
};

/**
 * Keeps an SSR outage distinct from a confirmed unauthenticated result while
 * serializing only the session data the root route needs for hydration.
 */
export function toRootAuthData<T>(result: SessionLoadResult<T>): RootAuthData<T> {
  return {
    authState: result.status,
    session: result.status === 'authenticated' ? result.session : null,
  };
}

export function shouldRedirectToLogin(authState: RootAuthData<unknown>['authState']): boolean {
  return authState === 'unauthenticated';
}
